export enum AttachmentType {
    Image = 'image',
    Video = 'video',
    File = 'file',
}
